module.exports = __webpack_public_path__ + "static/media/lullascape-1.8d878adc.jpg";